import { Box, Button, Divider, Modal, Slider, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import Subscription_free_user from "../../assets/baseVersion/Sunbscription_free_user.svg";
import Subscription_gold_user from "../../assets/baseVersion/Subscription_gold_user.svg";
import Subscription_diamond_user from "../../assets/baseVersion/Subscription_diamond_user.svg";
import Subscription_platinum_user from "../../assets/baseVersion/platinum-icon.svg";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import LetsTalk from "./LetsTalk";
import Subscription_free_user_white from "../../assets/baseVersion/favorite.svg";
import Subscription_Gold_white from "../../assets/baseVersion/gold_white.svg";
import Subscription_diamond_user_white from "../../assets/baseVersion/diamond_white.svg";
import Subscription_platinum_user_white from "../../assets/baseVersion/platinum_white.svg";

interface SubscriptionViewPlanProps {
  isViewPlans: boolean;
  setIsViewPlans: (isViewPlans: boolean) => void;
  onupgrade?: () => void;
}

const SubscriptionViewPlan: React.FC<SubscriptionViewPlanProps> = ({
  isViewPlans,
  setIsViewPlans,
  onupgrade,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
    const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 600,
    bgcolor: "background.paper",
    borderRadius: 2,
    p: 2,
    overflowY: "auto",
  };

  const plans = [
    {
      title: "Free",
      description: "For basic business plan with 14 days trial",
      defaultImage: Subscription_free_user,
      hoverImage: Subscription_free_user_white,
      SliderValue: 10,
    },
    {
      title: "Gold",
      description: "For basic business plan with 14 days trial",
      defaultImage: Subscription_gold_user,
      hoverImage: Subscription_Gold_white,
      SliderValue: 50,
    },
    {
      title: "Diamond",
      description: "For basic business plan with 14 days trial",
      defaultImage: Subscription_diamond_user,
      hoverImage: Subscription_diamond_user_white,
      SliderValue: 100,
    },
    {
      title: "Platinum",
      description: "For basic business plan with 14 days trial",
      defaultImage: Subscription_platinum_user,
      hoverImage: Subscription_platinum_user_white,
      SliderValue: 0, // Use a default numeric value for the slider
    },
  ];

  const handleClick = () => {
    setIsModalOpen(true);
  };

  return (
    <div>
      <Modal
        open={isViewPlans}
        onClose={(e: any, reason: string) => {
          if (reason === "escapeKeyDown" || reason === "backdropClick") {
            return;
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
            <CancelIcon
              onClick={() => {
                setIsViewPlans(false);
                onupgrade && onupgrade();
              }}
              sx={{ cursor: "pointer" }}
            />
          </Box>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Typography
              variant="body2"
              sx={{ fontSize: "21px", fontWeight: 500, mb: 2 }}
            >
              Pick the perfect{" "}
              <span style={{ color: "#3a2ada" }}>subscription plan</span>
            </Typography>
          </div>
          <Divider variant="inset" sx={{ mb: 2 }} />

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 20,
              padding: 10,
              height: 450,
            }}
          >
            {plans.map((plan, index) => (
              <div
                key={index}
                onMouseEnter={() => setHoveredIndex(index)} // Set hovered index
                onMouseLeave={() => setHoveredIndex(null)} // Reset hovered index
                style={{
                  border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #F3F3F9",  
                  background: hoveredIndex === index ? "#3A2ADA" : isDarkMode ? "#1A1A1A" : "#fbfbff", 
                  padding: "20px 16px",
                  borderRadius: "8px",
                  height: "100%",
                  width: 250,
                  display: "flex",
                  justifyContent: "center",
                  transition: "background 0.3s ease",
                  position: "relative", // Added position relative for absolute positioning of button
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={
                      hoveredIndex === index
                        ? plan.hoverImage
                        : plan.defaultImage
                    }
                    alt={plan.title}
                    style={{
                      marginBottom: "20px",
                      width: "50px", // Fixed width
                      height: "50px", // Fixed height
                      objectFit: "contain", // Ensure the image fits within the dimensions
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "800",
                      fontSize: "18px",
                      color: hoveredIndex === index ? "#fff" : isDarkMode ? "#fff" : "#000",
                    }}
                  >
                    {plan.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "12px",
                      color: hoveredIndex === index ? "#fff" : "#70708b",
                      textAlign: "center",
                      fontWeight: 400,
                    }}
                  >
                    {plan.description}
                  </Typography>
                  <Divider
                    variant="middle"
                    sx={{
                      width: "150px",
                      marginBottom: 2,
                      backgroundColor: hoveredIndex === index ? "#fff" : isDarkMode ? "#fff" : "#000",
                    }}
                  />

                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "12px",
                      fontWeight: 800,
                      textAlign: "left",
                      width: "100%",
                      color: hoveredIndex === index ? "#fff" : isDarkMode ? "#fff" : "#000",
                    }}
                  >
                    Features
                  </Typography>
                  {typeof plan.SliderValue === "number" ? (
                    <Slider
                      disabled
                      defaultValue={plan.SliderValue}
                      aria-label="Disabled slider"
                      size="small"
                      sx={{
                        color: "#6458E0", 
                        "&.Mui-disabled": {
                          color: "#6458E0",
                          opacity: 1, 
                        },
                        "& .MuiSlider-thumb": {
                          boxShadow: "0 0 0 4px rgba(63, 81, 181, 0.2)", // optional glow effect
                        },
                      }}
                    />
                  
                  ) : (
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "12px",
                        fontWeight: 800,
                        textAlign: "center",
                        color: hoveredIndex === index ? "#fff" : isDarkMode ? "#fff" : "#000",
                      }}
                    >
                      {plan.SliderValue}
                    </Typography>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 5,
                        justifyContent: "center",
                      }}
                    >
                      <CheckCircleOutlineOutlinedIcon fontSize="small" sx={{  color: hoveredIndex === index ? "#fff" : isDarkMode ? "#fff" : "#000" }} />
                      <Typography variant="body2" sx={{ fontSize: "13px",  color: hoveredIndex === index ? "#fff" : isDarkMode ? "#fff" : "#000"}}>
                        No limit of scans
                      </Typography>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 5,
                        justifyContent: "center",
                      }}
                    >
                      <CheckCircleOutlineOutlinedIcon fontSize="small"  sx={{  color: hoveredIndex === index ? "#fff" : isDarkMode ? "#fff" : "#000" }} />
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "13px", textAlign: "left",  color: hoveredIndex === index ? "#fff" : isDarkMode ? "#fff" : "#000" }}
                      >
                        Assets
                      </Typography>
                    </div>
                  </div>
                  {/* Move Let's Talk button outside the inner flex and to the bottom center */}
                  {(index === 1 || index === 2) && (
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                        width: "100%",
                        position: "absolute",
                        bottom: 30,
                        left: 0,
                        right: 0,
                      }}
                    >
                      <Button
                        variant="outlined"
                        sx={{
                          width: 120,
                          color: hoveredIndex === index ? "#3A2ADA" : isDarkMode ? "#fff" : "#000",
                          backgroundColor:
                            hoveredIndex === index ? "#F3F3F9" : "transparent",
                        }}
                        // disabled={true}
                        // onClick={handleClick}
                      >
                        Let's Talk
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Box>
      </Modal>
      {isModalOpen && (
        <div>
          <LetsTalk isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
        </div>
      )}
    </div>
  );
};

export default SubscriptionViewPlan;
